import React from "react";
import { Box, Editable, EditablePreview, EditableInput, Flex, 
  Input, Spacer, useColorModeValue,EditableTextarea,Select,
} from "@chakra-ui/react"
import { useDecisionTypesQuery,useUpdateDecisionMutation } from "../app/api.js"
import { map as m, path } from "ramda"; 
import { EditableControls } from "./editableText.js"
import { Participants } from "./participants.jsx"
import { useSelector } from "react-redux";

export const DecisionHeader = ({decision,id}) => {
  const {data:decisiontypes} =  useDecisionTypesQuery()
  const [updateFn] = useUpdateDecisionMutation();
  const lang = useSelector(path(["ui","lang"]));
  const texts = useSelector(path(["ui","ui_texts"]));
  const missing = useSelector(path(["ui","missing"]));

  const updateDecision = field => (value) => {updateFn({id,[field]:value});}
  const changeType = (event) => {updateFn({id,decision_type_id:event.target.value});}
  const color = useColorModeValue("gray.100", "gray.700");
  console.log({decisiontypes,decision});
  return decisiontypes && <Box mt={10} p={5} borderRadius={10} shadow="md" bg={'gray.50'}>
    <Editable fontSize='2xl' mt={2} mr={5} isPreviewFocusable={true} selectAllOnFocus={false} 
      defaultValue={decision.name || texts.decision_name} 
      onSubmit={updateDecision("name")}>
      <Flex>
        <EditablePreview />
        <Input as={EditableInput} />
        <Spacer/>
        <EditableControls />
      </Flex>
    </Editable>
    <Editable  mt={2} isPreviewFocusable={true} selectAllOnFocus={false} 
      defaultValue={decision.description  || texts.decision_desc}
      onSubmit={updateDecision("description")}>
      <Flex>
        <EditablePreview _hover={{background: color}}/>
        <Input as={EditableTextarea} />
        <Spacer/>
        <EditableControls  />
      </Flex>
    </Editable>
    <Select onChange={changeType} mt={2} placeholder={texts.choose_type} 
      value={decision.decision_type_id}> {
        m(x => <option key={x[lang === "en" ?  "name_eng":"name"]} value={x.id}>
          {x[lang === "en" ?  "name_eng":"name"]}
        </option>,decisiontypes)}
    </Select>
    <Participants id={id} />
  </Box>
}
